import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {};

const inventoryModule = {
  state,
  mutations,
  actions,
  getters,
};

export default inventoryModule;
